export default "__VITE_ASSET__QwJaifV4__"